import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function EPicAdmin() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/epictures").then((r) => setItems(r.data)); }, [api]);

  return (
    <div>
      <h1 className="font-serif text-3xl mb-2">e-Picture Orders</h1>
      <p className="text-xs text-[#8C867D] mb-6 uppercase tracking-widest">₹1 branded digital collectibles · auto-emailed on payment confirmation</p>
      <div className="admin-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[#8C867D] text-xs uppercase tracking-widest text-left">
            <tr><th className="p-3">Order</th><th>Product</th><th>Customer</th><th>Gmail ID</th><th>Phone</th><th>Address</th><th>Payment</th><th>Email</th></tr>
          </thead>
          <tbody>
            {items.map((o) => (
              <tr key={o.id} className="border-t border-[#27272A]" data-testid={`epic-row-${o.order_id}`}>
                <td className="p-3 font-mono text-xs">{o.order_id}</td>
                <td className="text-xs">{o.items?.[0]?.name}</td>
                <td className="text-xs">{o.epicture_details?.name || o.customer_name}</td>
                <td className="text-xs font-mono">{o.epicture_details?.email || o.customer_email}</td>
                <td className="text-xs">{o.epicture_details?.phone || "—"}</td>
                <td className="text-xs max-w-[200px] truncate">{o.epicture_details?.address || "—"}</td>
                <td className={`text-xs uppercase ${o.payment_status === "paid" ? "text-[#C5A059]" : "text-[#8C867D]"}`}>{o.payment_status}</td>
                <td className="text-xs">{o.email_sent ? <span className="text-[#C5A059]">Sent ✓</span> : o.payment_status === "paid" ? "Pending" : "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="8" className="p-8 text-center text-[#8C867D] text-sm">No e-picture orders yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
